import { useMemo, useState } from "react";

const useToggleOnFocus = (initialState = false) => {
  const [isFocused, toggle] = useState(initialState);

  const eventHandlers = useMemo(
    () => ({
      onFocus: () => toggle(true),
      onBlur: () => toggle(false)
    }),
    []
  );

  return [isFocused, eventHandlers];
};

export default useToggleOnFocus;
